import { render, staticRenderFns } from "./ButtonBayarTagihan.vue?vue&type=template&id=0d163b6c&"
import script from "./ButtonBayarTagihan.vue?vue&type=script&lang=js&"
export * from "./ButtonBayarTagihan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports